<div class="whole">
<div class="left-half">
    <img src="assets/img/user.png" alt="Blogger" height="150">

    <h3 style="font-size: 18px; font-weight:600">Satita Vittayaareekul</h3>
    <p>Finance & Computer Science @RU20'</p>
    <p>Thai based in VA, US</p>

    <hr style="width: 52%;">

    <div class="tag-option">
        <a class="blog-about">About</a>
        <a class="blog-tag">Tag</a>
        <a class="blog-current">Current Progress</a>
    </div>

    <!--Social Icons-->
    
    <div class="social-icons">
        <a href="#"><i class="fab fa-facebook-square"></i></a>
        <a href="#"><i class="fab fa-twitter"></i></a>
        <a href="#"><i class="fab fa-instagram"></i></a>
        <a href="#"><i class="fab fa-linkedin"></i></a>
    </div>
   
</div>

<div class="right-half">
    <!--<div markdown [src]="'assets/blog/blog.md'"></div>-->
    <!-- blog.component.html -->
    

    <ul aria-label="Blog posts">
    <li *ngFor="let blog of $blogPosts | async">
        <h1><a [routerLink]="blog.route">
        {{blog.title}} </a></h1>
        by {{blog.author}}, {{blog.date}} 
        <p style="color: #4056A1">{{blog.category}}</p>
        
        {{blog.description}}
        
        
    </li>
    <br>
    </ul>

</div>
</div>

